export default "__VITE_ASSET__Etp2F8QZ__"